import React from 'react'
import { Button, ButtonGroup, Card, Col, Row } from 'reactstrap';
import flag from '../../images/flag.png'
import { Popconfirm } from 'antd';
import { TbTrash } from 'react-icons/tb';
import { BiEdit } from 'react-icons/bi';

const Languages = ({ data, lang, t, deleteData, setSelectedItem, setModal, modal }) => {
    return (
        <Row className='my-3'>
            {
                data?.map((item, index) => {
                    return (
                        <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3' key={index}>
                            <Card>
                                <div><img src={flag} className='rounded w-100 h150px' /></div>
                                <div className='mt-3 d-flex justify-content-center align-items-center text-center'>
                                    <span>{item?.lang[lang]}</span>
                                    <strong className='ml-2'>({item.code})</strong>
                                </div>
                                <div className='text-center'><small>({item.zipCode})</small></div>
                                <div className='mt-3 mb-2 d-flex justify-content-center align-items-center'>
                                    <ButtonGroup>
                                        <div>
                                            <Popconfirm
                                                title={t("content_delete_desc")}
                                                onConfirm={() => deleteData(item?.id)}
                                                okText={t("yes")}
                                                cancelText={t("no")}
                                                getPopupContainer={(trigger) => trigger.parentNode}
                                            >
                                                <div className='bg-transparent cp br6 h40px px-2 d-flex align-items-center border text-danger'>
                                                    <TbTrash size={20} className='mt--3 mr-1' />
                                                    {t("delete2")}
                                                </div>
                                            </Popconfirm>
                                        </div>
                                        <Button
                                            className='bg-transparent border br6 text-warning'
                                            onClick={() => { setSelectedItem(item?.id); setModal(!modal) }}
                                        >
                                            <BiEdit size={20} className='mt--3 mr-1' />
                                            {t("edit2")}
                                        </Button>
                                    </ButtonGroup>
                                </div>
                            </Card>
                        </Col>
                    )
                })
            }
        </Row>
    )
}

export default Languages
